export default __webpack_public_path__ + "dim-bb5abb.json";